import React, { useEffect, useState } from 'react';
import StoreLocationsEditor from './StoreLocationsEditor';
import { Button, Table, TableBody, TableCell, TableHead, TableRow, IconButton, Dialog } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { ApiRequest } from 'GlobalFunctions';
import { HiOutlineMapPin } from "react-icons/hi2";
import { PiGearThin } from "react-icons/pi";
import { PiTrashLight } from "react-icons/pi";


export default function StoreLocations(props: any) {
    const [locations, setLocations] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [openEditor, setOpenEditor] = useState(false);
    const [editLocation, setEditLocation] = useState<any>(null);
    const store_id = localStorage.getItem('store_id');

    const fetchLocations = async () => {
        setLoading(true);
        await ApiRequest({
            method: 'GET',
            url: '/storesLocations/list',
            query: { store_id },
            setResponse: (res: any) => setLocations(res.list || [])
        });
        setLoading(false);
    };

    useEffect(() => {
        fetchLocations();
    }, []);

    const handleEdit = (location: any) => {
        setEditLocation(location);
        setOpenEditor(true);
    };

    const handleDelete = async (location: any) => {
        if (window.confirm('Delete this location?')) {
            setLoading(true);
            await ApiRequest({
                method: 'POST',
                url: '/storesLocations/deleteItem',
                body: { store_location_id: location.store_location_id },
                setResponse: () => fetchLocations()
            });
            setLoading(false);
        }
    };

    const handleAdd = () => {
        setEditLocation(null);
        setOpenEditor(true);
    };

    const handleCloseEditor = (refresh = false) => {
        setOpenEditor(false);
        setEditLocation(null);
        if (refresh) fetchLocations();
    };

    return (
        <div className="account_section">
            <div className="section_header">
                <h2>Store Locations</h2>
                <div className="section_actions">
                    <Button variant="text" onClick={handleAdd}>Add Location</Button>
                </div>
            </div>
            <div className='ModuleContent'>
                {loading ? <p>Loading...</p> : (
                    <div className="locations-container">
                        {locations.map((loc) => (
                            <div key={loc.store_location_id} className="location">
                                <HiOutlineMapPin size={20} color='#B9B9B9' />
                                <div>
                                    <div>{loc.address}</div>
                                    <div>{loc.city_name}, {loc.region_name}</div>
                                    <div>{loc.country_name}</div>
                                    <div>{loc.zip_code}</div>
                                </div>
                                <div className="location-actions">
                                    <IconButton onClick={() => handleEdit(loc)}><PiGearThin /></IconButton>
                                    <IconButton onClick={() => handleDelete(loc)}><PiTrashLight /></IconButton>
                                </div>
                            </div>
                        ))}
                </div>
                )}
            </div>
            <Dialog open={openEditor} onClose={() => handleCloseEditor()} maxWidth="sm" fullWidth>
                <StoreLocationsEditor 
                    location={editLocation} 
                    onClose={handleCloseEditor} 
                    store_id={store_id}
                />
            </Dialog>
        </div>
    );
}